// extracted by mini-css-extract-plugin
export default {"mission__card":"style_mission__card__9XoC6"};